import React from 'react';
import { motion } from 'framer-motion';
import { isEmpty, kebabCase } from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from '../layouts/BoxedContainer';
import { startEndDateToString } from '../../helpers/handleDates';
import Button from '../layouts/Button';
import { getAllPromotions } from '../../services/getAllPromotions';

export default function PromotionsList({ id }) {
  const promotions = getAllPromotions();

  if (isEmpty(promotions)) return null;
  const nullDate = '0001-01-01T00:00:00Z';
  const noDatesPromotions = promotions.filter((item) => item.startDate === nullDate);
  const datesPromotions = promotions.filter((item) => item.startDate !== nullDate);

  const sorted = [...datesPromotions, ...noDatesPromotions];

  return (
    <section id={id} className="md:pt-10 pt-5 lg:pb-[280px] pb-[90px] bg-bg-1">
      <BoxedContainer className="regular">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-[18px]"
        >
          {sorted.map((item, index) => (
            <div key={index} className="flex md:flex-row flex-col md:h-[390px] bg-white">
              <div
                className="md:w-1/2 bg-bg-7 flex justify-center items-center md:h-auto
                h-[250px]"
              >
                <LazyLoadImage
                  src={item.featuredImage.url}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div
                className="md:w-1/2 lg:py-[60px] md:py-[40px] py-[25px] xl:px-[72px] md:px-[35px]
                px-[20px] flex flex-col justify-between gap-y-4"
              >
                <div className="flex flex-col gap-y-4">
                  <h2
                    className="text-black lg:!text-xl lg:max-w-[370px] leading-[1.5]
                    font-roboto-condensed-bold uppercase"
                    style={{
                      fontSize: 'clamp(1.125rem, 0.305vw + 1.072rem, 1.438rem)',
                    }}
                  >
                    {item.title}
                  </h2>
                  {item.startDate === nullDate || (
                    <p
                      className="text-black uppercase font-roboto-condensed-bold"
                      style={{
                        fontSize: 'clamp(0.875rem, 0.122vw + 0.854rem, 1rem)',
                      }}
                    >
                      {startEndDateToString(item.startDate, item.endDate)}
                    </p>
                  )}
                </div>
                <p
                  className="text-black leading-[1.75] font-roboto-regular"
                  style={{
                    fontSize: 'clamp(0.875rem, 0.122vw + 0.854rem, 1rem)',
                  }}
                  dangerouslySetInnerHTML={{ __html: item.description }}
                />
                {isEmpty(item.bookingLink) || (
                  <Button
                    url={item.bookingLink.url}
                    label={item.bookingLink.name}
                    target={item.bookingLink.target}
                    ariaLabel={item.bookingLink.name}
                    tagName={kebabCase(item.bookingLink.name)}
                    external
                    variant="primaryRed"
                    text="w-[193px] min-w-[max-content] !h-[45px] !px-[28px]"
                  />
                )}
              </div>
            </div>
          ))}
        </motion.div>
      </BoxedContainer>
    </section>
  );
}